const shot = (id, w = 1600) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=${w}&q=80`;

export const photos = {
  hero: shot('photo-1538805060514-97d9cc17730c', 1800),
  gym: shot('photo-1534258936925-c58bed479fcb', 1400),
  lift: shot('photo-1599058917212-d750089bc07e', 1400),
  hiit: shot('photo-1571019613454-1cb2f99b2d8b', 1400),
  yoga: shot('photo-1549576490-b0b4831ef60a', 1200),
  bowl: shot('photo-1512621776951-a57141f2eefd', 1200),
  chicken: shot('photo-1473093295043-cdd812d0e601', 1200),
  meal: shot('photo-1504674900247-0877df9cc836', 1600),
  market: shot('photo-1534723452862-4c874018d66d', 1600),
  run: shot('photo-1551632811-561732d1e306', 2000),
  fresh: shot('photo-1543353071-873f17a7a088', 1400),
};
